import { Injectable } from "@angular/core";
import { NetworkService } from "../../common/network.service";

@Injectable()
export class UserMgmtService {
  constructor(private _networkService: NetworkService) { }

  getUserList() {

    return this._networkService.get("api/users/userList?download=true", null, null, "bearer");
  }
  getUserCourse(query: any) {
    return this._networkService.get("api/course/userCourse?" + query, null, null, "bearer");
  }
  getUserLesson(query: any) {
    return this._networkService.get("api/asr/submit/" + query, null, null, "bearer");
  }

  updateUserStatus(user: any) {
    return this._networkService.put("api/users", user, null, "bearer");
  }
  updateCoachingTime(user: any) {
    return this._networkService.post("api/coachingTime", user, null, "bearer");
  }
  
  SearchUserList(query: any) {
    return this._networkService.get("api/users/userList?" + query, null, null, "bearer");
  }
  getAuditlogs(query: any) {
    return this._networkService.get("api/auditLog?" + query, null, null, "bearer");
  }

  getUserlogs(query: any) {
    return this._networkService.get("api/useTime?"+ query, null, null, "bearer");
  }
  getUserlogsDownload(query: any) {
    return this._networkService.get("api/useTime/downloadList?"+ query, null, null, "bearer");
  }
  
  getVital(query: any) {
    return this._networkService.get("api/vital/?" + query, null, null, "bearer");
  }
  historyPayment(userId: any) {
    return this._networkService.get("api/subscription/payment/" + userId, null, null, "bearer");
  }
  getMonitorData() {
    return this._networkService.get("api/vital", null, null, "bearer");
  }



  deleteUser(param: any) {
    return this._networkService.delete("api/users/" + param, null, null, "bearer");
  }
  cancelSubscription(body: any) {
    return this._networkService.post("api/subscription/cancel", body, null, "bearer");
  }
  cancelTrail(body: any) {
    return this._networkService.post("api/subscription/cancel", body, null, "bearer");
  }
  AddTrail(body: any) {
    return this._networkService.post("api/subscription", body, null, "bearer");
  }
  modifySubsciption(body: any) {
    return this._networkService.post("api/subscription/admin/modify", body, null, "bearer");
  }
  sendMessageApi(body: any) {
    return this._networkService.post("api/chat", body, null, "bearer");
  }
  getChatList(query:any) {
    return this._networkService.get("api/chat/individual?"+query, null, null, "bearer");
  }
  getUserTimeActivity(query:any) {
    return this._networkService.get("api/useTime/useTimeDetails?"+query, null, null, "bearer");
  }

  deleteChat(param: any) {
    return this._networkService.delete("api/chat/message/" + param, null, null, "bearer");
  }
  getCoachingDetail(query:any) {
    return this._networkService.get("api/coachingTime/list?"+query, null, null, "bearer");
  }
  syncUsers(query:any) {
    return this._networkService.get("api/users/excelUpload?"+query, null, null, "bearer");
  }
}

